import React from "react";
import { Box, GridItem, Heading, Flex } from "@chakra-ui/react";
import {
  DatePicker,
  Form,
  Grid,
  NumberInput,
  Select,
  TextInput
} from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import { Breed, Procedures, Species } from "./components";
import { constants, hooks, Types, utils } from "./duck";

const PatientInformation: React.FC = () => {
  const defaultValues = useCurrentCase(medicalCase =>
    utils.getPatientInfo(medicalCase.data.client.patient)
  );
  const { dateFormat } = useOrganizationSettings();

  const onChange = hooks.useUpdatePatient();

  return (
    <Box>
      <Heading color="black" fontSize="18px">
        Patient Information
      </Heading>
      <Form<Types.FormValues>
        mt={4}
        validationSchema={utils.getValidationSchema()}
        defaultValues={defaultValues}
      >
        <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
        <Grid templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}>
          <GridItem>
            <TextInput
              name="name"
              label="Patient Name"
              placeholder="Patient Name"
            />
          </GridItem>
          <GridItem>
            <Species defaultValue={defaultValues.species} />
          </GridItem>
          <GridItem>
            <Breed />
          </GridItem>
          <GridItem>
            <DatePicker
              name="dateOfBirth"
              label="Date of Birth"
              maxDate={new Date()}
              placeholderText="Date of Birth"
              dateFormat={dateFormat}
            />
          </GridItem>
          <GridItem>
            <Select
              name="sex"
              label="Sex"
              placeholder="Sex"
              options={constants.SEX_OPTIONS}
            />
          </GridItem>
          <GridItem>
            <Flex columnGap={5}>
              <NumberInput
                name="weight"
                label="Weight"
                placeholder="Weight"
                min={0}
              />
              <Select
                isClearable={false}
                name="weightMeasure"
                label="Weight Measure"
                labelHidden
                options={constants.WEIGHT_MEASURE_OPTIONS}
                inputLayoutProps={{ mt: 8 }}
              />
            </Flex>
          </GridItem>
          <GridItem>
            <DatePicker
              name="procedureDate"
              label="Procedure date"
              placeholderText="Procedure date"
              isClearable={false}
              futureYears={5}
              dateFormat={dateFormat}
            />
          </GridItem>
          <GridItem>
            <TextInput name="alerts" label="Alerts" placeholder="Alerts" />
          </GridItem>
          <GridItem colSpan={2}>
            <Procedures />
          </GridItem>
        </Grid>
      </Form>
    </Box>
  );
};

export default PatientInformation;
